import styled from "styled-components";

export const CheckboxContainer = styled.label<{ isRadioButton: boolean, disabled: boolean }>`
	display: block;
	position: relative;
	cursor: pointer;
	font-size: 1.375rem;
	user-select: none;
	width: 24px;
	height: 24px;
	min-width: 24px;
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
		&:checked {
			~ {
				.checkmark {
					background-color: ${props => (props.disabled ? "#ccc" : "#2c76aa")};
					border: none;
					&:after {
						display: block;
					}
				}
			}
		}
	}
	@media (min-width: 1024px) {
		&:hover {
			input {
				~ {
					.checkmark {
						background-color: #ccc;
						border: none;
					}
					border: 1px solid #dfe4ea;
				}
			}
		}
	}
	.checkmark {
		&:after {
			left: 7px;
			top: 4px;
			width: 6px;
			height: 10px;
			border-style: solid;
			border-color: white;
			border-image: initial;
			border-width: 0px 2px 2px 0px;
			transform: rotate(45deg);
		}
	}

	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 20px;
		width: 20px;
		background-color: #fff;
		border-radius: ${props => (props.isRadioButton ? "45px" : "5px")};
		border: 1px solid #dfe4ea;
		&:after {
			content: "";
			position: absolute;
			display: none;
		}
	}
`;
